import {
  Wifi,
  Tv,
  Snowflake,
  ChefHat,
  WashingMachine,
  Coffee,
  ArrowUpDown,
  BedDouble,
  Bath,
  Users,
} from "lucide-react";

export const AMENITY_ICONS = {
  WiFi: Wifi,
  "Smart TV": Tv,
  AC: Snowflake,
  "Air Conditioning": Snowflake,
  Kitchen: ChefHat,
  "Washing Machine": WashingMachine,
  "Coffee Machine": Coffee,
  Elevator: ArrowUpDown,
};

export const BASE_ICONS = {
  Bedrooms: BedDouble,
  Bathrooms: Bath,
  Guests: Users,
};
